"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return /*#__PURE__*/_react["default"].createElement("span", null, "::");
});
var DragRightView = (0, _reactSortableHoc.SortableElement)(function (props) {
  return /*#__PURE__*/_react["default"].createElement(DragHandle, null);
});

var PropsToDragRightView = function PropsToDragRightView(params) {
  return /*#__PURE__*/_react["default"].createElement(DragRightView, {
    index: params.node.rowIndex
  });
};

var _default = PropsToDragRightView;
exports["default"] = _default;